const addDays = (days = 0, date) => {
  const updatedDate = new Date(date);
  updatedDate.setDate(updatedDate.getDate() + days);
  return updatedDate;
};
const addMonths = (months = 0, date) => {
  const updatedDate = new Date(date);
  updatedDate.setMonth(updatedDate.getMonth() + months);
  return updatedDate;
};

const DEFAULT_DATE_FORMAT = 'DD/MM/YY';

const formatDate = (date, format = DEFAULT_DATE_FORMAT, isEpoch = false) => {
  if (!date) return '';
  const MMM = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const MMMM = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const DDD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  if (isEpoch) date = new Date(date * 1000);
  else date = new Date(date);

  const year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  const dayInWeek = date.getDay();
  let hours = date.getHours().toString();
  let mins = date.getMinutes().toString();
  let secs = date.getSeconds().toString();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  if (hours.length < 2) hours = `0${hours}`;
  if (mins.length < 2) mins = `0${mins}`;
  if (secs.length < 2) secs = `0${secs}`;

  if (format.indexOf('-a') > -1) {
    const meridian = hours >= 12 ? 'PM' : 'AM';
    format = format.replace('-a', meridian);
  }

  if (format.indexOf('-A') > -1) {
    const meridian = hours >= 12 ? 'pm' : 'am';
    format = format.replace('-A', meridian);
  }

  if (format.indexOf('YYYY') > -1) format = format.replace('YYYY', year);
  else if (format.indexOf('YY') > -1) format = format.replace('YY', year.substr(2, 2));

  if (format.indexOf('MMMM') > -1) format = format.replace('MMMM', MMMM[parseInt(month) - 1]);
  else if (format.indexOf('MMM') > -1) format = format.replace('MMM', MMM[parseInt(month) - 1]);
  else if (format.indexOf('MM') > -1) format = format.replace('MM', month);

  if (format.indexOf('DDD') > -1) format = format.replace('DDD', DDD[parseInt(dayInWeek)]);
  else if (format.indexOf('DDd') > -1) {
    let suffix = '';
    if (day % 10 === 1) suffix = 'st';
    else if (day % 10 === 2) suffix = 'nd';
    else if (day % 10 === 3) suffix = 'rd';
    else suffix = 'th';
    format = format.replace('DDd', day + suffix);
  } else if (format.indexOf('DD') > -1) format = format.replace('DD', day);

  if (format.indexOf('HH') > -1) format = format.replace('HH', hours);

  if (format.indexOf('hh') > -1) {
    const hour12 = hours > 12 ? hours - 12 : hours;
    format = format.replace('hh', hour12);
  }

  if (format.indexOf('mm') > -1) format = format.replace('mm', mins);

  if (format.indexOf('ss') > -1) format = format.replace('ss', secs);

  return format;
};

export default {
  addDays,
  addMonths,
  formatDate,
};
